//DEFINE FOR ROCKY RESULT
export const MERGE_PDN = "Merged PDN"
export const MERGE_SIGNAL = "Merged Signal"
export const COMBINED_PDN_AND_SIGNAL = "combined PDN and signal"
export const SINGLE_PATTERN = "Single Pattern"
export const PATTERN_SWEEP = "Pattern Sweep"
export const COMP_INFO = "compInfo"
export const WAVE_FORM_LIST = "waveFormList"
export const EXIST_COLOR = "existColor"
export const HAVE_EXPANDED_SIGNAL = "haveExpandedSignal"
export const SELECTED_COMPONENT_KEYS = "selectedComponentKeys"
export const SELECTED_PATTERN_KEYS = "selectedPatternKeys"
export const PATTERN_SWEEP_LIST = "patternSweep"
export const DIFF_SIGNAL_NAME = "diffSignalName"
export const PATTERN_INFO = "patternInfo"
export const VIX_ID_LIST = ['vix_dq', 'vix_ca'];
// export const SEPARATE_PACKAGE = "Separate Package";
// export const SEPARATE_PCB = "Separate PCB";
// export const MERGED = "Merged";
export const PDN_IMPEDANCE = "PDN Impedance";

// SYS result type
export const SYS_RESULT_TYPES = {
  SYS_SEPARATE_PCB: "Separate PCB",
  SYS_SEPARATE_PACKAGE: "Separate Package",
  SYS_MERGED: "Merged",
};

export const {
  SYS_SEPARATE_PCB,
  SYS_SEPARATE_PACKAGE,
  SYS_MERGED,
} = SYS_RESULT_TYPES;
export const SYS_RESULT_TYPE_KEYS = Object.keys(SYS_RESULT_TYPES);

// SYS result type
export const RESULT_TYPES = {
  SEPARATE_PCB: "Separate PCB",
  SEPARATE_PACKAGE: "Separate Package",
  MERGED: "Merged",
  CASCADE_PCB_PKG: "Cascade_pcb_pkg"
};

export const {
  SEPARATE_PCB,
  SEPARATE_PACKAGE,
  MERGED,
  CASCADE_PCB_PKG
} = RESULT_TYPES;
export const RESULT_TYPE_KEYS = [SEPARATE_PCB, SEPARATE_PACKAGE, CASCADE_PCB_PKG];

const MENU_KEYS = {
  CHANNEL: 'channel',
  IMPEDANCE: 'impedance',
  IMPEDANCE_PDN: 'impedance_pdn',
  CROSSTALK: 'crosstalk',
  WAVEFORM: 'waveform',
  TDR: 'TDR',
  EYE_DIAGRAM: 'eyediagram',
  MARGINS: 'margins',
  POWER_SUM: 'powerSum',
  DECAP: 'decap',
  DELAY: 'delay',
  IBIS: 'IBIS',
  EXP_EYE_DIAGRAM: 'exp_eye_diagram',
  EXP_MARGINS: 'exp_margins',
  VTF_COMPLIANCE: 'vtf_compliance'
};

export const {
  CHANNEL,
  IMPEDANCE,
  IMPEDANCE_PDN,
  CROSSTALK,
  WAVEFORM,
  TDR,
  EYE_DIAGRAM,
  MARGINS,
  POWER_SUM,
  DECAP,
  DELAY,
  IBIS,
  EXP_EYE_DIAGRAM,
  EXP_MARGINS,
  VTF_COMPLIANCE
} = MENU_KEYS;

export const MEMORY_RESULT_KEYS = [CHANNEL, IMPEDANCE_PDN, POWER_SUM, TDR];
export const ADS_RESULT_KEYS = [CHANNEL, POWER_SUM, TDR, EYE_DIAGRAM]

export const PACKAGE_SEV_CHANNEL_RESULT = "package_sev_channel_result";

export const OVER_UNDER_SHOOT_KEYS = ['shoot_margin', 'value_pass', 'shoot_time', 'shoot_voltage', 'shoot_voltage_spec', 'area_margin', 'area_margin2', 'area_pass', 'area2_pass'];
export const OVER_UNDER_SHOOT_NAMES = ['Overshoot Margin', 'Overshoot Area Margin', 'Overshoot Area Margin2', 'Undershoot Margin', 'Undershoot Area Margin', 'Undershoot Area Margin2',
  'Differential Overshoot Margin', 'Differential Undershoot Margin', 'Differential Overshoot Area Margin', 'Differential Undershoot Area Margin'];
